<template>
  <el-dialog
    :lock-scroll="false"
    :visible.sync="dialogVisible"
    @close="onCancleBtn"
    :close-on-click-modal="false"
    title="添加/修改规则配置"
  >
    <el-form
      class="rule-form"
      ref="addOrEditForm"
      label-width="150px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="规则类型" prop="rulesType">
        <el-select v-model="form.rulesType" placeholder="请选择">
          <el-option
            v-for="item in rulesType"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="欠费次数" prop="numberArrears">
        <el-input  v-model.number="form.numberArrears"></el-input>
      </el-form-item>
      <el-form-item label="欠费总金额" prop="amountArrears">
        <el-input  v-model.number="form.amountArrears"></el-input>
      </el-form-item>
      <el-form-item label="欠费时长(天数)" prop="durationArrears">
        <el-input  v-model="form.durationArrears"></el-input>
      </el-form-item>
      <el-form-item label="是否启用" prop="activitFlag">
        <el-switch
          v-model="form.activitFlag"
          active-color="#13ce66"
          inactive-color="#6666"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addOrEditTrue">确定</el-button>
      <el-button @click="onCancleBtn">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { RULES_TYPE } from "../contants";
import { updateOneRuleConfiguration } from "@/api/url.js";

export default {
  props: {
    oneDetail: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      rulesType: RULES_TYPE,
      dialogVisible: true,
      detailList: [],
      form: {},
      rules: {
        durationArrears: [
          {
            required: true,
            message: "请输入欠费时长",
            trigger: "change",
          },
         
        ],

        numberArrears: [
          { type: "number", message: "请输入数字" },
        ],
        amountArrears: [
          { type: "number", message: "请输入数字"},
        ],
      },
    };
  },
  mounted() {
    this.initDetails();
  },
  methods: {
    onCancleBtn() {
      this.$emit("func", "cancle");
    },
    addOrEditTrue() {
      const { id } = this.form;
      this.$refs.addOrEditForm.validate((vali) => {
        if (vali) {
          const {activitFlag}=this.form
          if (id) {

            this.$putRequest(`${updateOneRuleConfiguration()}/${id}`, {
              ...this.form,
              activitFlag:activitFlag?'y':'n'
            }).then((res) => {
              const { status, message } = res;
              if (status === 200) {
                this.$emit("func", "edit");
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                this.$message({
                  type: "warning",
                  message,
                });
              }
            });
          } else {
            this.$postRequest(updateOneRuleConfiguration(), {
              ...this.form,
              activitFlag:activitFlag?'y':'n'
             
            }).then((res) => {
              const { status, message } = res;
              if (status === 200) {
                this.$emit("func", "add");
                this.$message({
                  type: "success",
                  message: "添加成功",
                });
              } else {
                this.$message({
                  type: "warning",
                  message,
                });
              }
            });
          }
        }
      });
    },
    
    initDetails() {
      if (this.oneDetail) {
        const {
          id,
          rulesType,
          numberArrears,
          amountArrears,
          durationArrears,
          activitFlag,
         
        } = this.oneDetail;
        this.form = {
          id,
          rulesType,
          numberArrears,
          amountArrears,
          durationArrears,
          activitFlag,
        };
      }
    },
  },
};
</script>
<style scoped lang="scss">
.time-group {
  display: flex;
  justify-content: space-between;
  .el-form-item {
    width: 50%;
    .el-date-editor.el-input {
      width: 100%;
      max-width: 100%;
    }
  }
}
.active-detail {
  border: 1px dashed #eee;
  border-radius: 10px;
  margin: 10px;
  box-sizing: border-box;
  padding: 20px;
  h6 {
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .active-detail-list {
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding-bottom: 10px;
      margin-bottom: 10px;
      &:not(:last-child) {
        border-bottom: 1px dashed #eee;
      }
      dl {
        width: 30%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        dt {
          width: 100px;
          font-weight: normal;
          color: #606266;
          font-size: 14px;
        }
      }
    }
  }
}

.el-icon-delete {
  font-size: 20px;
  color: #409eff;
  cursor: pointer;
}
.add-icon {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .el-icon-circle-plus-outline {
    font-size: 40px;
    color: #409eff;
    cursor: pointer;
  }
}

</style>
<style>
.rule-form {
  .el-select {
    display: block;
  }

  .el-form-item__content {
    height: 30px;
    line-height: 30px;
  }
}

</style>
